import type { BarSeriesOption } from 'echarts';
import { Bar, ChartECOption } from '../types';

export interface GetChartSeriesOptionArgs extends Pick<BarSeriesOption, 'barWidth' | 'barMinHeight'> {
  data: (Bar | null)[];
  containerWidth: number;
}

export function getChartSeriesOption({
  data,
  barWidth,
  barMinHeight,
  containerWidth,
}: GetChartSeriesOptionArgs): ChartECOption['series'] {
  return [
    {
      type: 'bar',
      barGap: '1.75px',
      barMinHeight: barMinHeight || Math.floor(containerWidth / data.length) - 5,
      itemStyle: {
        borderRadius: 100,
      },
      barWidth: barWidth || Math.floor(containerWidth / data.length) - 5,
      data,
    },
  ];
}
